import {
  LogLevelFilterActionTypes,
  LogLevelFilterTypes,
} from 'containers/LogPage/store/actions/logPage.actions';
import { LOG_LEVELS } from 'helpers/global.config';
import { TimeFilterProps } from 'hooks/useDateTimeFilter';
import { IntegrationEvents } from 'models/integrationEvents';
import { Pagination } from 'models/Pagination';
import { startOfDay, endOfDay, formatISO } from 'date-fns';

interface LogFilterState {
  dates: TimeFilterProps;
  logLevels: string[];
  provider?: string;
}

export interface LogPageState {
  filters: LogFilterState;
  data: IntegrationEvents[];
  pagination: Pagination;
  isLoading: boolean;
  error: string;
}

const date = new Date;

const initialState: LogPageState = {
  filters: {
    dates: {
      start: formatISO(startOfDay(date)),
      end: formatISO(endOfDay(date)),
    },
    logLevels: LOG_LEVELS.map((level) => level.name.toLocaleLowerCase()),
  },
  data: [],
  pagination: { pageElements: 30, totalPages: 1, actualPage: 1 },
  isLoading: false,
  error: '',
};

export default function reducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: LogLevelFilterActionTypes,
): LogPageState {
  switch (action.type) {
    case LogLevelFilterTypes.CHANGE_DATETIME_FILTER:
      return {
        ...state,
        filters: { ...state.filters, dates: action.payload.data },
      };
    case LogLevelFilterTypes.CHANGE_LOGLEVEL_FILTER:
      return {
        ...state,
        filters: { ...state.filters, logLevels: action.payload.data },
      };
    case LogLevelFilterTypes.CHANGE_PROVIDER_FILTER:
      return {
        ...state,
        filters: { ...state.filters, provider: action.payload.data },
      };
    case LogLevelFilterTypes.CHANGE_PAGE_FILTER:
      return {
        ...state,
        pagination: { ...state.pagination, actualPage: action.payload.data },
      };
    case LogLevelFilterTypes.SEARCH_LOGS:
      return {
        ...state,
        isLoading: true,
      };
    case LogLevelFilterTypes.SEARCH_LOGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case LogLevelFilterTypes.SEARCH_LOGS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.data,
      };
    default:
      return state;
  }
}
